import { render, staticRenderFns } from "./MainInfoOfPublicTender.vue?vue&type=template&id=5ae512e8&scoped=true&"
import script from "./MainInfoOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./MainInfoOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./MainInfoOfPublicTender.vue?vue&type=style&index=0&id=5ae512e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae512e8",
  null
  
)

export default component.exports